(function pngackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["PureCounter"] = factory();
	else
		root["PureCounter"] = factory();
})(self, function() {
return 